export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9274.34e36582.jpg";